import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import InfiniteScroll from 'react-infinite-scroller';
import AppCircularProgress from '../AppCircularProgress/AppCircularProgress';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    width: '100%',
  },
}));

const InfiniteScrollPagination = ({ children, isLoading, filters, fetchFunction }) => {
  const classes = useStyles();
  const count = Math.ceil(filters.total / filters.limit);
  const handleChange = () => {
    if (!isLoading) fetchFunction({ limit: filters.limit, page: filters.page+1 });
  };
  const isEmpty = !filters.total;

  if (isEmpty) {
    return null;
  }
  return (
    <div className={classes.root}>
      <InfiniteScroll
        pageStart={0}
        style={{ width: '100%' }}
        loadMore={handleChange}
        hasMore={filters.page < count}
        loader={
          <div className="loader" key={filters.page}>
            <AppCircularProgress />
          </div>
        }
      >
        {children}
      </InfiniteScroll>
    </div>
  );
};

InfiniteScrollPagination.propTypes = {
  fetchFunction: PropTypes.func,
  filters: PropTypes.shape({
    limit: PropTypes.number,
    page: PropTypes.number,
    total: PropTypes.number,
  }),
};

InfiniteScrollPagination.defaultProps = {
  fetchFunction: () => {},
  filters: {
    limit: 20,
    page: 1,
    total: 0,
  },
};

export default InfiniteScrollPagination;
